import React from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import AdminSidebar from "./AdminSidebar";

const AdminLayout = () => (
  <div
    className="min-h-screen bg-[#080A0F] text-[#F3F4F6] flex"
    data-testid="admin-dashboard-shell"
  >
    <AdminSidebar />
    <div className="flex-1 md:ml-64">
      <main className="px-4 sm:px-6 lg:px-8 py-8 md:py-10 max-w-6xl">
        <Outlet />
      </main>
    </div>
    <Toaster theme="dark" position="top-right" richColors />
  </div>
);

export default AdminLayout;
